import { useNavigate } from 'react-router-dom';
import styles from '../styles/app.module.css';

export function MakeYourOwnButton() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className={styles.makeYourOwn}
      onClick={() => navigate('/builder')}
      aria-label="Make your own custom photobooth"
    >
      <span aria-hidden className={styles.makeYourOwnSpark}>✦</span>
      <span className={styles.makeYourOwnLabel}>Make your own</span>
    </button>
  );
}
